
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitopandharpurcabs() {



    const cardData =
    {
        keyword: 'Mumbai to Pandharpur Cab Service',
        heading: 'Vedant Travels:  Mumbai to Pandharpur Cab Service',
        headingDescription: 'Experience a comfortable and hassle-free journey from Mumbai to Pandharpur with Vedant Travels reliable cab service. Whether you are a devotee visiting the sacred Vitthal-Rukmini Temple or a traveler exploring the city rich spiritual heritage, we provide well-maintained sedans, SUVs, and luxury cars to suit all your travel needs. Our professional drivers, competitive fares, 24/7 availability, and flexible pickup & drop-off options ensure a smooth and convenient trip.',

        top: 'Top Places to Visit in Pandharpur with Vedant Travels',

"topPlaces": [
    {
        "title": "Vitthal-Rukmini Temple",
        "description": "The main attraction of Pandharpur, this temple is dedicated to Lord Vitthal (a form of Lord Krishna) and Goddess Rukmini. It is a major pilgrimage site, drawing millions of devotees, especially during Ashadhi Ekadashi and Kartiki Ekadashi yatras."
    },
    {
        "title": "Pundalik Temple",
        "description": "Located on the banks of the Chandrabhaga River, this temple is dedicated to Saint Pundalik, a great devotee of Lord Vitthal. The temple holds great significance as it marks the origin of Pandharpur’s devotion to Vitthal."
    },
    {
        "title": "Chandrabhaga River (Bhima River)",
        "description": "A holy river where devotees take a ritualistic dip before visiting the Vitthal Temple. The river is believed to have spiritual cleansing powers, making it a must-visit spot for pilgrims."
    },
    {
        "title": "Vishnupad Temple",
        "description": "Located near the riverbank, this temple is known for the sacred footprints of Lord Vishnu. Devotees believe that offering prayers here brings peace and prosperity."
    },
    {
        "title": "Kaikadi Maharaj Math",
        "description": "A unique spiritual and cultural center, this math (monastery) features caves depicting mythological stories from Hindu scriptures. It offers visitors an immersive experience of India’s rich spiritual heritage."
    },
    {
        "title": "Gopalpur (Gopal Krishna Temple)",
        "description": "A serene location just a few kilometers from Pandharpur, this temple is dedicated to Lord Krishna and is surrounded by natural beauty and greenery, making it an ideal spot for meditation."
    },
    {
        "title": "Iskcon Pandharpur",
        "description": "A beautifully built ISKCON temple promoting devotional practices and Bhagavad Gita teachings. It is a great place for spiritual seekers looking for peaceful surroundings and divine chants."
    },
    {
        "title": "Namdev Payari (Steps of Devotion)",
        "description": "These are the sacred steps leading to the Vitthal Temple, named after Saint Namdev, one of Lord Vitthal's most ardent devotees. Devotees believe that bowing here grants spiritual blessings."
    },
    {
        "title": "Sant Dnyaneshwar Samadhi",
        "description": "Located nearby, this samadhi (memorial) is dedicated to Saint Dnyaneshwar, a revered saint and philosopher of the Bhakti movement. It is a peaceful place for prayers and reflection."
    },
    {
        "title": "Sant Tukaram Temple",
        "description": "Dedicated to Sant Tukaram, another prominent Bhakti saint, this temple attracts devotees who admire his poetic hymns (Abhangas) and teachings."
    }
],

"services": [
    {
        "name": "Mumbai to Pandharpur Cab by Vedant Travels",
        "description": "Book your ride with Vedant Travels for a comfortable and reliable journey from Mumbai to Pandharpur. Whether you're traveling for a religious pilgrimage or a family trip, our well-maintained vehicles and professional drivers ensure a smooth ride to Pandharpur."
    },
    {
        "name": "Pandharpur Taxi Service",
        "description": "Vedant Travels offers efficient and safe taxi services for your trip to Pandharpur. Our experienced drivers ensure a smooth and pleasant journey, making your visit to the sacred town stress-free and comfortable."
    },
    {
        "name": "Mumbai to Pandharpur One Way Taxi",
        "description": "Need a one-way taxi from Mumbai to Pandharpur? Vedant Travels offers flexible one-way taxi services for your convenience. Whether you're visiting for a religious event or simply for a peaceful getaway, we ensure a smooth and hassle-free ride."
    },
    {
        "name": "Pandharpur Temple Tour",
        "description": "Take a spiritual journey to the famous Pandharpur Temple with Vedant Travels. Our Pandharpur Temple tour includes professional drivers, comfortable vehicles, and a relaxed atmosphere, allowing you to focus on your pilgrimage while we handle the transportation."
    },
    {
        "name": "Mumbai to Pandharpur Taxi Fare",
        "description": "Vedant Travels provides competitive and transparent pricing for your journey to Pandharpur. We offer fair taxi fares with no hidden charges, ensuring you get the best value for your trip. Contact us for an accurate fare estimate."
    },
    {
        "name": "Pandharpur Cab Booking",
        "description": "Booking your cab for Pandharpur is easy with Vedant Travels. We offer quick and simple booking options for your convenience. Whether you’re planning a one-way or round-trip journey, we ensure that your ride is comfortable and timely."
    },
    {
        "name": "Mumbai to Pandharpur Car Rental",
        "description": "Looking for a car rental service from Mumbai to Pandharpur? Vedant Travels offers flexible rental options, ensuring you travel in comfort and style. Choose from a wide range of vehicles and enjoy a smooth journey to Pandharpur."
    },
    {
        "name": "Pandharpur Trip from Mumbai",
        "description": "Make your Pandharpur trip memorable with Vedant Travels. Our reliable taxi services provide a comfortable and convenient way to travel from Mumbai to Pandharpur, ensuring your journey is smooth and enjoyable from start to finish."
    },
    {
        "name": "Mumbai to Pandharpur Innova",
        "description": "For a premium and comfortable journey, book an Innova for your trip to Pandharpur. The Innova offers ample space, luxury, and comfort, making it perfect for family trips or groups traveling to Pandharpur."
    },
    {
        "name": "Mumbai to Pandharpur Round Trip",
        "description": "Vedant Travels offers round-trip services from Mumbai to Pandharpur, ensuring a reliable and comfortable experience both ways. Our round-trip taxi services are designed for convenience, allowing you to enjoy a stress-free visit and return journey."
    }
],



"tableData": [
    ["Mumbai to Pandharpur Cab", "Pandharpur Taxi Service"],
    ["Mumbai to Pandharpur One Way Taxi", "Pandharpur Temple Tour"],
    ["Mumbai to Pandharpur Taxi Fare", "Pandharpur Cab Booking"],
    ["Mumbai to Pandharpur Car Rental", "Pandharpur Trip from Mumbai"],
    ["Mumbai to Pandharpur Innova", "Mumbai to Pandharpur Round Trip"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality. Whether you're traveling for religious purposes, a pilgrimage, or a leisure trip, our drivers ensure that your Mumbai to Pandharpur journey is on time, smooth, and hassle-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Travel in comfort with our fleet of spacious and well-maintained vehicles. Our cars are designed for long journeys, offering air conditioning, comfortable seating, and ample legroom to ensure a relaxing experience."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are experienced professionals who know the best routes for your Mumbai to Pandharpur trip. They ensure that you have a safe and smooth ride, with expert knowledge of the local roads and conditions."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive, transparent pricing with no hidden charges. We provide you with upfront pricing, so you know exactly what to expect, offering great value for your money on your Pandharpur journey."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. Our fleet is well-maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a secure and worry-free journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you prefer to depart early in the morning or return late at night, Vedant Travels is available 24/7. Our customer service team is always ready to assist you with your booking or any inquiries."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Pandharpur cab is simple and convenient. You can easily make a reservation via our website or mobile app, or reach out to our customer service team for assistance."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer personalized travel packages for your Pandharpur trip. Whether you're visiting for religious purposes or leisure, we can tailor the trip to suit your schedule, preferences, and comfort."
    }
  ]


    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Pandharpur cab with Vedant Travels?',
            answer: 'You can book your cab online through our website or mobile app. Alternatively, you can contact our customer service team for assistance in booking your cab.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are experienced in long-distance travel. They are knowledgeable about the route to Pandharpur and ensure a safe and smooth journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Pandharpur travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are equipped for a comfortable, long-distance ride.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Pandharpur cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip to Pandharpur?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details during booking, and we will ensure a smooth return trip from Pandharpur to Mumbai.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated upfront. We value transparency and ensure you know exactly what you\'re paying for.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Pandharpur?',
            answer: 'Yes, we offer sightseeing services as part of your Mumbai to Pandharpur journey. Visit famous landmarks such as the Pandharpur Vithoba Temple and other nearby attractions with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Pandharpur cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or specialized luggage, please let us know during booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Pandharpur?',
            answer: 'Yes, we provide corporate travel services for business trips, conferences, and team outings to Pandharpur. We ensure a professional and comfortable travel experience for corporate clients.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Pandharpur travel?',
            answer: 'Vedant Travels provides a reliable, comfortable, and affordable travel experience. With experienced drivers, well-maintained vehicles, and transparent pricing, we ensure that your journey to Pandharpur is safe, smooth, and memorable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Shankar Patil",
            title: "Pilgrim",
            quote: "I traveled to Pandharpur from Mumbai with Vedant Travels for a pilgrimage. The car was very comfortable, and the driver was courteous and knowledgeable. We had a smooth journey and reached on time. Highly recommended!",
            rating: 5,
        },
        {
            name: "Mrs. Geeta Deshmukh",
            title: "Family Traveler",
            quote: "Our family took a trip from Mumbai to Pandharpur with Vedant Travels. The journey was pleasant, and the vehicle was clean and spacious. The driver was very professional and ensured we had a comfortable trip. We will definitely use their services again!",
            rating: 5,
        },
    ];
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    

  
 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pandharpur Cab",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-pandharpur-cab.jpg",
  "description": "Book Mumbai to Pandharpur cab with Vedant Travels for a safe and comfortable pilgrimage trip to the holy town of Pandharpur. AC sedans, SUVs, and tempo travellers available for one-way and round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4399",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-pandharpur-cab"
  }
};



  
   
      


    return (
        <div>
<Helmet>
  <title>Mumbai to Pandharpur Cab | Comfortable Pilgrimage Ride | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pandharpur cab with Vedant Travels for a safe and comfortable pilgrimage trip to the holy town of Pandharpur. AC sedans, SUVs, and tempo travellers available for one-way and round trips." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pandharpur Cab, Pandharpur Pilgrimage Cab Mumbai, Mumbai to Pandharpur Taxi, Vedant Travels Mumbai Pandharpur, Pilgrimage Cab Booking Mumbai, AC Cab Mumbai Pandharpur, SUV Cab Mumbai Pandharpur, Outstation Cab Mumbai Pandharpur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/86.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopandharpurcabs;